import { render, staticRenderFns } from "./showCertificate.vue?vue&type=template&id=d17210d4"
import script from "./showCertificate.vue?vue&type=script&lang=js"
export * from "./showCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports